const Config = {
  // 域名
  hostUrl: 'https://tinkle.fenaor.com',
  // hostUrl: 'http://jinquanlai.dev.ztbweb.cn',
  // 端名
  controlName: 'User',
  // 版本
  version:'1.1.2',
  // api格式
  apiFormat: 'hostUrl/controlName/modularName/actionName',
  // 全局请求头
  header: {},
  // 返回成功码
  successCode: [200, 403, 404],
  // 忽略提示返回码
  ignoreToastCode: [500, 402, 401],
  tokenStorageKey: 'Ztbtoken',
  // 接口返回code处理
  codeHandle: {
    200: (res, again) => {},
    401: (res, again) => {}
  }
}

export default Config
